<template>
  <v-container>
    <v-row class="justify-center pt-5">
      <v-col cols="12">
        <v-card class="mx-auto pa-5" outlined>
          <v-card-title>{{ lg_department_add.title }}</v-card-title>
          <v-divider></v-divider>
          <br />
          <v-form @submit.prevent="submit">
            <v-select
              v-validate="'required'"
              :items="mDataArray"
              :label="lg_department_add.company_select"
              item-text="company_name"
              item-value="id"
              v-model="department.id_company"
              outlined
              @change="changeCompany"
            ></v-select>

            <v-text-field
              outlined
              :label="lg_department_add.department_name"
              v-model="department.department"
            ></v-text-field>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="mr-4" @click.prevent="cancel">
                {{ lg_department_add.btn_cancel }}
              </v-btn>

              <v-btn color="success" type="submit">
                {{ lg_department_add.btn_save }}
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <LoadingDialog></LoadingDialog>
    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" max-width="60%">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->
  </v-container>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "../../components/cards/LoadingDialog.vue";
import { server } from "../../services/constants";

import { feature } from "../../services/constants";
import { lg_department_add } from "../language/lg_department";

export default {
  name: "department-create",
  beforeCreate() {
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_department_add = lg_department_add.department_add_th)
      : (this.lg_department_add = lg_department_add.department_add_en);

    // console.log("lg_department_add: " + JSON.stringify(this.lg_department_add));
  },
  data: () => ({
    alertDlg: false,
    titleMessageAlert: "",
    messageAlert: "",
    department: {
      department: "",
      id_company: 0,
    },
    mDataArray: [],
  }),
  components: {
    LoadingDialog,
  },
  async mounted() {
    this.loadCompany();
    // this.department.id_company = localStorage.getItem(server.COMPANYID);
  },
  methods: {
    async changeCompany(selectObj) {
      // console.log(selectObj);
    },
    async loadCompany() {
      let result = null;
      this.department.id_company = parseInt(
        localStorage.getItem(server.COMPANYID)
      );

      if (localStorage.getItem(server.ROLE) == "Admin") {
        result = await api.getCompanyNotGuest();
      } else {
        result = await api.getCompanyByID(this.department.id_company);
      }

      this.mDataArray = result.data;
      // console.log(JSON.stringify(result.data));
      // this.department.id_company = result.data.id;
      // console.log(this.department.id_company);
    },
    async submit() {
      // console.log(server.Department_URL);
      // console.log(JSON.stringify(this.Department));
      // alert(JSON.stringify(this.Department));

      // this.department.id_company = localStorage.getItem(server.COMPANYID);

      this.$store.state.loadMenu = true;
      const result = await api.checkByNameDepartment(
        this.department.department,
        this.department.id_company
      );

      if (result.data != null) {
        // this.titleMessageAlert = "กรุณาตรวจสอบข้อมูล";
        // this.messageAlert =
        //   "Department นี้ถูกใช้งานแล้ว กรุณาเปลี่ยน Department ใหม่";
        this.titleMessageAlert = this.lg_department_add.titleMessageAlert;
        this.messageAlert = this.lg_department_add.messageAlert;
        this.alertDlg = true;
        this.$store.state.loadMenu = false;
      } else {
        await api.addDepartment(this.department);
        // this.$store.state.loadMenu = false;
        this.$router.back();
      }
    },
    cancel() {
      this.$router.back();
    },
  },
};
</script>

<style></style>
